var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3563L11.2998 10.0565C13.1223 8.23407 13.1223 5.27928 11.2998 3.45683C9.4774 1.63439 6.52261 1.63439 4.70017 3.45683C2.87772 5.27928 2.87772 8.23407 4.70017 10.0565L8 13.3563ZM8 15.2419L3.75736 10.9993C1.41421 8.65614 1.41421 4.85717 3.75736 2.51403C6.10051 0.170881 9.89947 0.170881 12.2427 2.51403C14.5858 4.85717 14.5858 8.65614 12.2427 10.9993L8 15.2419ZM8 8.09C8.7364 8.09 9.33333 7.49307 9.33333 6.75667C9.33333 6.02029 8.7364 5.42334 8 5.42334C7.2636 5.42334 6.66667 6.02029 6.66667 6.75667C6.66667 7.49307 7.2636 8.09 8 8.09ZM8 9.42334C6.52724 9.42334 5.33333 8.2294 5.33333 6.75667C5.33333 5.28391 6.52724 4.09 8 4.09C9.47273 4.09 10.6667 5.28391 10.6667 6.75667C10.6667 8.2294 9.47273 9.42334 8 9.42334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapPin);
export default __webpack_public_path__ + "static/media/iconMapPin.ab52e2081c33e7e391e9d07798f475c8.svg";
export { ForwardRef as ReactComponent };